import React from 'react';
import { fmtUsd, fmtDollar, fmtSignalTime } from '../utils/fmtPrice';

function fmtSignedUsd(n) {
  const v = Number(n);
  if (!Number.isFinite(v)) return '—';
  const s = fmtUsd(Math.abs(v));
  if (v > 0) return `+${s}`;
  if (v < 0) return `-${s}`;
  return s;
}

function netClass(n) {
  const v = Number(n);
  if (!Number.isFinite(v) || v === 0) return 'fc-net-zero';
  return v > 0 ? 'fc-pos' : 'fc-neg';
}

function NetUsdCell({ value }) {
  return (
    <span className={`fc-net-usd ${netClass(value)}`}>
      <strong>{fmtSignedUsd(value)}</strong>
    </span>
  );
}

function sideLabel(side) {
  if (!side) return '—';
  return side === 'long' ? 'Long' : 'Short';
}

function marginCell(t) {
  return (
    <>
      {fmtUsd(t.marginUsd)} margin · {t.leverage}x (≈ {fmtUsd(t.notionalUsd)})
    </>
  );
}

export function FcOpenTradesTable({ trades, showUser = false }) {
  if (!trades?.length) return null;
  return (
    <table className="fc-table fc-trade-table">
      <thead>
        <tr>
          <th>Trade ID</th>
          <th>Opened (CST)</th>
          <th>Action</th>
          {showUser && <th>User</th>}
          <th>Symbol</th>
          <th>Side</th>
          <th>Size</th>
          <th>Entry $</th>
          <th>Mark $</th>
        </tr>
      </thead>
      <tbody>
        {trades.map((t) => (
          <tr key={`open-${t.id}`} className={`fc-trade-row fc-trade-${t.side}`}>
            <td>
              <code className="fc-trade-id">{t.tradeId || '—'}</code>
            </td>
            <td>{fmtSignalTime(t.openedAt)}</td>
            <td>
              <span className="fc-action fc-action-open">{t.action || 'OPEN'}</span>
            </td>
            {showUser && <td>{t.email || t.userId || '—'}</td>}
            <td>
              <strong>{t.symbol}</strong>
            </td>
            <td>{sideLabel(t.side)}</td>
            <td>{marginCell(t)}</td>
            <td>{fmtDollar(t.entryPx)}</td>
            <td>{fmtDollar(t.markPx)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export function FcClosedTradesTable({ trades, showUser = false }) {
  if (!trades?.length) return null;
  return (
    <table className="fc-table fc-trade-table">
      <thead>
        <tr>
          <th>Trade ID</th>
          <th>Opened (CST)</th>
          <th>Closed (CST)</th>
          <th>Action</th>
          {showUser && <th>User</th>}
          <th>Symbol</th>
          <th>Side</th>
          <th>Size</th>
          <th>Entry $</th>
          <th>Exit $</th>
          <th>Net $</th>
          <th>Exit</th>
        </tr>
      </thead>
      <tbody>
        {trades.map((t) => (
          <tr key={`close-${t.id}`} className={`fc-trade-row fc-trade-${t.side}`}>
            <td>
              <code className="fc-trade-id">{t.tradeId || '—'}</code>
            </td>
            <td>{fmtSignalTime(t.openedAt)}</td>
            <td>{fmtSignalTime(t.closedAt)}</td>
            <td>
              <span className="fc-action fc-action-close">{t.action || 'CLOSE'}</span>
            </td>
            {showUser && <td>{t.email || t.userId || '—'}</td>}
            <td>
              <strong>{t.symbol}</strong>
            </td>
            <td>{sideLabel(t.side)}</td>
            <td>{marginCell(t)}</td>
            <td>{fmtDollar(t.entryPx)}</td>
            <td>{fmtDollar(t.exitPx)}</td>
            <td>
              <NetUsdCell value={t.traderNetUsd} />
            </td>
            <td>{t.exitReason || '—'}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
